export default "__VITE_ASSET__8e61f2f8__"